/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

const medal = {
  background: 'url(/img/medal.svg) center center no-repeat',
  lineHeight: '36px',
  width: '44px',
  height: '44px',
  fontFamily: 'open sans,Helvetica,sans-serif',
  fontSize: '24px',
  fontWeight: '600',
  color: '#fff',
  textShadow: '0 1px 1px rgba(0,0,0,.1)'
};

const contestTypeDescIcon = type => {
  if ([1, 5].includes(type)) {
    return <i className="fa fa-rub" />;
  } else if ([3, 4].includes(type)) {
    return <i className="fa fa-user" />;
  } else if ([6].includes(type)) {
    return <i className="fa fa-star" />;
  }
  return null;
};

const ContestView = props => (
  <li className="media media_table media_default media_padding-adp media_md">
    <div className="media-left media-middle media-icon media-icon_lg media-icon_medal">
      {props.place ? (
        <div className="media-data" style={medal}>
          {props.place}
        </div>
      ) : null}
    </div>
    <div className="media-left media-avatar media-middle">
      {props.contestPrize ? (
        <span
          className="avatar avatar_bordered avatar_fill"
          title={props.contestPrize.title}
          style={{
            backgroundImage: `url(${props.contestPrize.photoUrl})`
          }}
        />
      ) : null}
    </div>
    <div className="media-body media-middle">
      {props.contestPrize ? (
        <div className="media-content">
          <div className="media-info" title={props.contestPrize.title}>
            <h3 className="media-info-name text-overflow">
              {props.contestPrize.title}{' '}
              <span className="hidden-sm hidden-md hidden-lg">
                , {props.contestPrize.desc}
              </span>
            </h3>
            <div className="media-info-desc text-overflow hidden-xs">
              {props.contestPrize.desc}
            </div>
            <div className="media-info-desc text-overflow visible-xs">
              3164 реферала
            </div>
          </div>
          <div className="media-content-data text-overflow hidden-sm hidden-md hidden-lg">
            {props.contestUser ? (
              <React.Fragment>
                <i className="far fa-user-circle fa-fw" />{' '}
                {props.contestUser.username}
              </React.Fragment>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
    <div className="media-right media-middle media-avatar hidden-xs">
      {props.contestUser ? (
        <span
          className="avatar avatar_bordered avatar_fill"
          title={props.contestUser.username}
          style={{
            backgroundImage: `url(${props.contestUser.avatarPath})`
          }}
        />
      ) : null}
    </div>
    <div
      className="media-right media-middle w-100 hidden-xs"
      style={{ width: '100px' }}
    >
      {props.contestUser ? (
        <div className="media-content">
          <div className="media-info">
            <h4
              className="media-info-name text-overflow"
              title={props.contestUser.username}
            >
              {props.contestUser.username}
            </h4>
            <div
              className="media-info-desc text-nowrap"
              title={props.contestsDescItemType.valueDesc}
            >
              {contestTypeDescIcon(props.contestsDescItemType.type)}{' '}
              {props.contestUser.calculatedDesc}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  </li>
);

ContestView.defaultProps = {
  place: null,
  contestPrize: null,
  contestUser: null
};

ContestView.propTypes = {
  // CONNECT STATES
  contestsDescItemType: PropTypes.shape({
    type: PropTypes.number.isRequired,
    valueDesc: PropTypes.string.isRequired
  }).isRequired,
  place: PropTypes.number,
  contestPrize: PropTypes.shape({
    title: PropTypes.string.isRequired,
    photoUrl: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired
  }),
  contestUser: PropTypes.shape({
    username: PropTypes.string.isRequired,
    avatarPath: PropTypes.string.isRequired,
    calculatedDesc: PropTypes.string.isRequired
  })
};

export default ContestView;



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestView/ContestPlacesList/ContestPlacesItem/ContestPlacesItem.js